import React from 'react';
import PropTypes from 'prop-types';
import { Page } from 'framework7-react';

import { APP_MODES } from 'Constants';

import { BaThankYou, DonorResultNotSaved, DonorThankYou, LoadingScreen } from './subviews';

const thankYouType = {
  admin: <BaThankYou />,
  agent: <BaThankYou />,
  donor: <DonorThankYou />
};

const ThankYou = ({ donorResultNotSaved = false, mode = 'agent', uploadMediaLoading = false }) => {
  const thankYouPage =
    mode === APP_MODES.DONOR && donorResultNotSaved ? <DonorResultNotSaved /> : thankYouType[mode] || <BaThankYou />;
  return <Page>{uploadMediaLoading ? <LoadingScreen /> : thankYouPage}</Page>;
};

ThankYou.propTypes = {
  donorResultNotSaved: PropTypes.bool,
  mode: PropTypes.string,
  uploadMediaLoading: PropTypes.bool
};

export default ThankYou;
